//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ServiceCrossType {
	Site = 0,
	Plant = 1,
	SiteAndPlant = 2
}
